import { connect } from 'react-redux';

import EditGroupSetDialog from './EditGroupSetDialog';

import {
  operations as groupOperations,
  selectors as groupSelectors,
} from '../../../../../store/groups';

const mapStateToProps = (state) => {
  const setId = groupSelectors.editGroupSetDialogOpenFor(state);
  const groupSet = setId && groupSelectors.groupSet(state, setId);

  return {
    setId,
    name: groupSet && groupSet.name,
    isHidden: groupSet && groupSet.isHidden,
    isLocked: groupSet && groupSet.isLocked,
    open: !!setId,
    saving: groupSelectors.isEditingGroupSet(state),
    deleting: groupSelectors.isDeletingGroupSet(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onSave: (setId) => (groupSet) =>
    dispatch(groupOperations.editGroupSet({ id: setId, ...groupSet })),
  onDelete: (setId) => () => dispatch(groupOperations.deleteGroupSet(setId)),
  onClose: () => dispatch(groupOperations.closeEditGroupSet),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  onSave: dispatchProps.onSave(stateProps.setId),
  onDelete: dispatchProps.onDelete(stateProps.setId),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(EditGroupSetDialog);
